<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.0005 7L10.0005 12.5L15.0005 18" stroke="currentColor" />
  </svg>
</template>
